import React, {Component} from 'react';
import axios from 'axios';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { setCurrentUser, setFechaHoraActividad, userLogout } from '../redux/user/user-actions';
import { selectAspirante, selectCurrentUser, selectFechaHoraActividad } from '../redux/user/user-selectors';
import Template from './interfaz/Template';
import TemplateExterno from './interfaz/TemplateExterno';
import { login_tiempo_inactividad } from '../ApplicationResources';
import * as etiquetas from '../ApplicationResources';

class AuthenticatedComponent extends Component {
	//state = {cargado: false};

	constructor(props) {
		super(props);

		this.state = {
			cargado: false
		};
	}

	validarActividad = () => {
		const {datosUsuario, fechaHoraActividad} = this.props;
		var fechaHoraActual = new Date();

		if(datosUsuario !== undefined) {
			if(!fechaHoraActividad) {
				// Almacenamos la fecha y hora actual ya que no existe aún en la store
				this.props.setFechaHoraActividad(fechaHoraActual.getTime());
			} else {
				// Obtenemos la diferencia de fecha en horas
				var minutosTranscurridos = (fechaHoraActual.getTime() - fechaHoraActividad)/3600000;
				
				if(minutosTranscurridos >= login_tiempo_inactividad)
					// Cerramos sesión después del tiempo especificado
					this.cerrarSesion();
				else
					// Actualizamos la fecha y hora de la actividad
					this.props.setFechaHoraActividad(fechaHoraActual.getTime());
			}
		}
	}

	/**
	 * Función que permite cerrar la sesión del usuario después del tiempo de inactividad especificado
	 */
	cerrarSesion = () => {
		const jwt = localStorage.getItem('jwt-token');

		if (jwt) {
			axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/cierraSesion', {
				idSistema:etiquetas.idSistema
			},
			{
				headers: { Authorization: jwt}
			}).finally(() => {
				localStorage.removeItem('jwt-token');

				this.props.history.push({
					pathname: '/loginSEyCAE',
					state: { inactividad: true }
				});

				this.props.terminarSesion();
			});
		}
		else {
			localStorage.removeItem('jwt-token');
			
			this.props.history.push({
				pathname: '/loginSEyCAE',
				state: { inactividad: true }
			});

			this.props.terminarSesion();
		}
	}

	componentDidMount() {
		this.validarActividad();

 		const jwt = localStorage.getItem('jwt-token');

 		if (!jwt && this.props.privado) {
			 this.props.history.push('/loginSEyCAE');
			 return;
		}
		else if (!jwt && !this.props.privado) {
			this.setState({cargado: true}, this.props.listo);
			return;
		}

		var busca = this.props.datosUsuario === undefined;
		var datos = this.props.datosUsuario;
		const pathname = this.props.history.location.pathname;

		if(busca && jwt && jwt.length > 0) {
			axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/recupera_datos', {
				busca: busca,
				idSistema: etiquetas.idSistema
		   },
		   {
			   headers : {Authorization: jwt},
		   }).then(res => {
				datos = res.data.entity.datosUsuario;
				localStorage.setItem('jwt-token', datos.tknJWT);
				this.props.establecerSesion(datos);
			}).catch(err => {
			   this.setState({cargado: true});
			   this.cerrarSesion();
		   });
		}

		this.setState({cargado: true}, this.props.listo);

		if (datos && datos.tipoUsuario === 'E' && !this.props.externo) 
			this.props.history.push('/enConstruccion');
		else if (datos && datos.tipoUsuario === 'I' && !this.props.privado) {
			if (pathname === '/loginSEyCAE'){
				this.props.history.push('/menuJDE');
			}
		}

		if (datos.tipoUsuario === 'E' && pathname === '/loginSEyCAE') {
			if (datos.datosAspirante.estatusRegistro === 1){
				if (pathname !== '/cargaDocumentos')
					this.props.history.push('/cargaDocumentos');
			}
			else if(datos.datosAspirante.estatusRegistro === 2) {
				if (datos.datosAspirante.bObservacion) {
					if (pathname !== '/cargaDocumentos')
						this.props.history.push('/cargaDocumentos');
				}
				else if (typeof datos.datosAspirante.bObservacion !== "number" &&
						 datos.datosAspirante.bPlatica === 0) {
					if (pathname !== '/finalizado')
						this.props.history.push('/finalizado');
				}
				else if (pathname !== '/platica_induccion')
					this.props.history.push('/platica_induccion'); 
			}
			else if (datos.datosAspirante.estatusRegistro === 3) {
				if (pathname !== '/finalizado')
					this.props.history.push('/finalizado');
			}
			else if (datos.datosAspirante.estatusRegistro === 4 || datos.datosAspirante.estatusRegistro === 5) {
				if (pathname !== '/solicitud_declinada')
					this.props.history.push('/solicitud_declinada');
			}
			else
				this.props.history.push('/enConstruccion');
		}
 	}

 	render() {
		if (!this.state.cargado && this.props.datosUsuario)
			return <Template guia={false} bloqueado={true}/>;
		else if (!this.state.cargado)
			return <TemplateExterno bloqueado={true} enlaces={false}/>;

 		return this.props.children;
 	}
 }

AuthenticatedComponent.defaultProps = {
	externo: true,
	privado: true,
}

const mapStateToProps = createStructuredSelector({
	datosUsuario: selectCurrentUser,
	fechaHoraActividad: selectFechaHoraActividad,
	datosAspirante: selectAspirante
});

const mapDispatchToProps = dispatch => ({
	terminarSesion: () => dispatch(userLogout()),
	establecerSesion: user => dispatch(setCurrentUser(user)),
	setFechaHoraActividad: fechaHoraActividad => dispatch(setFechaHoraActividad(fechaHoraActividad))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent));